import React, { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Button, Modal } from "react-bootstrap";
import "./Css/IPassModule.css";
import GreyArrow from "../assets/greyLeftAr.png";
import Header from "./Header.js";
import {
  server_post_data,
  get_ipass_toll_unused_data,
} from "../ServiceConnection/serviceconnection.js";
import {
  goBack,
  handleError,
  mondayDayYearFormat,
} from "../CommonJquery/CommonJquery.js";
import Loader from "./Loader.js";
const OfficeUseTolls = ({ showSection }) => {
  // Dummy data for I-Passes
  const [ipassData, setIpassData] = useState([]);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [noteViewModalOpen, setViewNoteModalOpen] = useState(false);
  const [noteView, setNoteView] = useState(" ");

  useEffect(() => {
    master_data_get(0);
  }, []);

  const master_data_get = async (call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", call_id);
    fd.append("flags", "officeusetolls");
    await server_post_data(get_ipass_toll_unused_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setIpassData(Response.data.message.data);
          console.log(Response.data.message.data);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // Add these state variables after other useState declarations
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);

  // Add this pagination logic after your filter handlers
  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    ipassData && ipassData?.length > 0
      ? ipassData.slice(indexOfFirstItem, indexOfLastItem)
      : [];
  const totalPages =
    ipassData && ipassData.length > 0
      ? Math.ceil(ipassData.length / itemsPerPage)
      : 0;

  // Handler for page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  const statusData = [
    { value: "1", label: "Harsh Rane - 01" },
    { value: "2", label: "Anirban Panja - 02" },
    { value: "3", label: "Rohan Yadav - 03" },
    { value: "4", label: "Harsh Rane - 04" },
    { value: "5", label: "Anirban Panja - 05" },
    { value: "6", label: "Rohan Yadav - 06" },
    { value: "7", label: "Harsh Rane - 07" },
  ];

  const openNoteViewModal = (Id) => {
    setViewNoteModalOpen(true);
    setNoteView(Id);
  };

  return (
    <>
      <Header />
      {showLoaderAdmin && <Loader />}
      <div className="ipass-container container-fluid p-0">
        {/* Header Section */}
        <div className="pageCntn_head">
          <div className="pageNameDiv">
            <p className="breadcrumb-item">Office Used Tolls</p>

            <img
              src={GreyArrow || "/placeholder.svg"}
              alt="Rapid Car Leasing"
            />
          </div>
          <Button onClick={goBack} className="Back_bttn_page">
            <ArrowLeft size={17} style={{ marginBottom: "2px" }} /> Back
          </Button>
        </div>

        {/* Table Section */}
        <div className="card ipass-card ipass-table-card mb-4">
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover ipass-table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Sr. No.</th>
                    <th>Entry Date</th>
                    <th>I-Pass No.</th>
                    <th>Car No.</th>
                    <th>Amount</th>
                    <th>Type</th>
                    <th>Exit Date</th>
                    <th>Posting Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems &&
                    currentItems.length > 0 &&
                    currentItems.map((ipass, index) => (
                      <tr key={ipass.id}>
                        <td style={{ fontSize: "14px" }}>
                          {indexOfFirstItem + index + 1}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {mondayDayYearFormat(ipass.entry_date)}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {ipass.ipass_tagid}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {ipass.ipass_car_no}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          ${ipass.ipass_amount}
                        </td>
                        <td style={{ fontSize: "14px" }}>{ipass.ipass_type}</td>
                        <td style={{ fontSize: "14px" }}>
                          {console.log(
                            mondayDayYearFormat(ipass.ipass_exit_date)
                          )}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {mondayDayYearFormat(ipass.ipass_posting_date)}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          <div
                            className="actioniconstest"
                            style={{ gap: "1rem", width: "60%" }}
                          >
                            <button
                              className="tbnWhiteNew"
                              type="button"
                              style={{
                                whiteSpace: "nowrap",
                                fontSize: "13px",
                              }}
                              onClick={() =>
                                openNoteViewModal(ipass.office_use_notes)
                              }
                            >
                              View Note
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="cust_hist_card_footer">
              <div className="cust_hist_pagination_info">
                {ipassData && ipassData.length > 0 ? (
                  <>
                    Showing{" "}
                    <span className="cust_hist_pagination_bold">
                      {indexOfFirstItem + 1}
                    </span>{" "}
                    to{" "}
                    <span className="cust_hist_pagination_bold">
                      {Math.min(indexOfLastItem, ipassData.length)}
                    </span>{" "}
                    of{" "}
                    <span className="cust_hist_pagination_bold">
                      {ipassData.length}
                    </span>{" "}
                    I-Passes
                  </>
                ) : (
                  <>
                    Showing <span className="cust_hist_pagination_bold">0</span>{" "}
                    I-Passes
                  </>
                )}
              </div>
              <div className="cust_hist_pagination">
                <nav aria-label="Pagination">
                  <ul className="cust_hist_pagination_list">
                    {renderPaginationButtons()}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* note view modal */}
      <Modal
        show={noteViewModalOpen}
        onHide={() => setViewNoteModalOpen(false)}
        className="ipass-modal"
        centered
      >
        <Modal.Header
          style={{ backgroundColor: "var(--primary-color)" }}
          closeButton
        >
          <Modal.Title style={{ color: "#fff" }}>Note for Toll</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="assignForm">
            <div className="mb-3">
              <label
                htmlFor="assignmentNotes"
                className="form-label ipass-form-label"
              >
                Notes
              </label>
              <textarea
                id="assignmentNotes"
                name="notes"
                rows="3"
                className="form-control"
                placeholder="Add any additional information about this assignment"
                disabled
                value={noteView}
              ></textarea>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default OfficeUseTolls;
